var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g2, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 124,
    viewBox: "0 0 147 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7562_78532",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 2,
    width: 40,
    height: 52
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3351 23.0318C35.3267 29.9651 39.3504 50.5762 49.8671 53.8306C60.3839 57.0851 78.433 12.2449 75.6565 4.77547C72.8799 -2.69401 40.0343 13.4797 37.3351 23.0318Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7562_78532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.2607 -3.01183L31.4922 1.70703L39.5571 59.2465L84.3256 54.5276L76.2607 -3.01183Z",
    fill: "#F2950D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.7461 0.4879C83.8779 13.3739 77.1488 30.848 61.721 39.5085C54.6642 43.6256 46.38 45.133 38.1725 43.7933C34.6111 43.1635 31.1806 41.7866 28.0945 39.7483L35.2413 38.9959L29.8441 0.537447L60.6565 -2.70633L59.4358 -11.4044C66.823 -10.0182 73.1802 -5.95508 76.7461 0.4879Z",
    fill: "#F2950D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.1867 0.797372C83.1937 13.4321 76.5939 30.5504 61.4581 39.0557C54.5285 43.1006 46.3926 44.5815 38.3322 43.265C34.8382 42.6435 31.4727 41.2918 28.4437 39.2933L35.1339 38.589L29.827 0.774177L26.4377 1.13098C29.2156 -2.00373 32.4816 -4.63388 36.1111 -6.65918L37.0153 -0.216081L60.3424 -2.67184L59.1949 -10.8484C66.4704 -9.51278 72.6991 -5.51386 76.1867 0.797372Z",
    fill: "#F2960D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6411 1.12135C82.502 13.5233 76.0259 30.3221 61.1912 38.6642C54.4049 42.6223 46.4384 44.0697 38.5466 42.7784C35.1114 42.1767 31.8016 40.8538 28.8231 38.8921L35.0642 38.2351L31.1001 9.98787L20.9638 11.055C24.031 3.62529 29.4438 -2.42766 36.3511 -6.15198L37.1832 -0.222987L60.0671 -2.63217L58.9893 -10.3122C66.0925 -8.98695 72.2127 -5.06427 75.6411 1.12135Z",
    fill: "#F2970D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.0777 1.39936C81.8114 13.5343 75.4692 30.0073 60.9248 38.1787C54.2786 42.0548 46.4771 43.4739 38.7478 42.2124C35.3848 41.6179 32.1451 40.3197 29.2291 38.3981L34.9981 37.7908L31.1179 10.1424L21.5276 11.152C24.5174 3.85675 29.8143 -2.09172 36.5827 -5.75511L37.3566 -0.240798L59.7833 -2.60184L58.7767 -9.77506C65.7342 -8.52797 71.7299 -4.63892 75.0777 1.39936Z",
    fill: "#F2980D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.5445 1.73742C81.1235 13.6235 74.9131 29.7552 60.674 37.7541C54.1698 41.5546 46.5291 42.9405 38.9629 41.692C35.6706 41.1297 32.4965 39.8717 29.6407 37.9974L34.9522 37.4382L31.1454 10.3123L22.101 11.2644C25.035 4.12597 30.2221 -1.69468 36.8472 -5.28274L37.5521 -0.259988L59.5065 -2.57131L58.5732 -9.22223C61.8148 -8.74793 64.9408 -7.51304 67.7099 -5.61282C70.4791 -3.71261 72.8174 -1.19786 74.5445 1.73742Z",
    fill: "#F2990D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.9832 2.06885C80.4388 13.6956 74.3651 29.5583 60.4055 37.267C46.4459 44.9758 29.9283 42.0356 23.4853 30.3919L33.8196 29.3038L31.1795 10.4904L22.6315 11.3904C25.4949 4.39477 30.572 -1.30956 37.0608 -4.82165L37.7079 -0.210518L59.218 -2.47522L58.3553 -8.6234C61.5228 -8.15685 64.5774 -6.95099 67.2859 -5.09791C69.9944 -3.24482 72.2851 -0.793506 73.9832 2.06885Z",
    fill: "#F29A0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.4512 2.39396C79.7492 13.7661 73.7992 29.2027 60.1706 36.8733C46.5421 44.544 30.3649 41.5235 24.0712 30.182L33.7811 29.1598L31.1939 10.7246L23.2401 11.562C26.0415 4.72329 31.0078 -0.851753 37.354 -4.28195C50.9761 -11.9987 67.1511 -8.99354 73.4512 2.39396Z",
    fill: "#F29B0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.8876 2.70192C79.0603 13.8221 73.2422 28.9171 59.9043 36.4168C46.5664 43.9165 30.7842 41.0415 24.6133 29.8276L33.7328 28.8675L31.2017 10.832L23.8235 11.6088C26.571 4.92836 31.4269 -0.518246 37.6283 -3.875C50.922 -11.37 66.7275 -8.43514 72.8876 2.70192Z",
    fill: "#F29C0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.3568 3.00869C78.3749 13.8802 72.6886 28.6342 59.6705 35.96C46.6524 43.2857 31.1904 40.3458 25.164 29.5219L33.7081 28.6224L31.2352 11.0015L24.3734 11.7239C27.0492 5.18815 31.7905 -0.142887 37.8504 -3.42935C50.8854 -10.7413 66.3388 -7.86284 72.3568 3.00869Z",
    fill: "#F29D0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7957 3.33323C77.6738 13.9544 72.134 28.3656 59.4065 35.5204C46.6789 42.6752 31.5632 39.8548 25.7146 29.2305L33.6684 28.3931L31.2494 11.1563L24.9336 11.8213C27.5535 5.4423 32.185 0.23908 38.1017 -2.97205C50.84 -10.0501 65.9155 -7.30333 71.7957 3.33323Z",
    fill: "#F29E0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.254 3.62347C76.9835 13.9328 71.5695 28.0654 59.1916 35.043C46.8138 42.0206 32.0528 39.272 26.3 28.9028L33.6781 28.1261L31.3196 11.3197L25.5056 11.9318C28.0539 5.69895 32.5797 0.619106 38.3645 -2.50133C50.7845 -9.49897 65.5012 -6.7457 71.254 3.62347Z",
    fill: "#F29F0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6984 3.93214C76.2966 14.0527 71.0479 27.7627 58.9035 34.5911C46.7592 41.4194 32.4094 38.721 26.8134 28.6159L33.6014 27.9012L31.2989 11.4942L26.0603 12.0457C28.5515 5.96542 32.9666 1.00823 38.6083 -2.04306C50.7379 -8.86987 65.1003 -6.18839 70.6984 3.93214Z",
    fill: "#F2A00D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2111 4.23662C75.6717 14.1116 70.4788 27.4947 58.6914 34.1322C46.904 40.7698 32.8036 38.1836 27.3261 28.2947C21.8486 18.4059 27.0585 5.03668 38.8458 -1.6009C50.6332 -8.23847 64.6789 -5.61527 70.2111 4.23662Z",
    fill: "#F2A10D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4907 33.5041C70.1499 27.0954 75.2356 14.1875 69.85 4.67349C64.4643 -4.84051 50.6468 -7.35786 38.9877 -0.949171C27.3286 5.45952 22.2429 18.3674 27.6285 27.8814C33.0141 37.3954 46.8316 39.9127 58.4907 33.5041Z",
    fill: "#F2A20D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1526 32.7949C70.5445 26.5078 75.4947 13.8703 70.2091 4.56819C64.9235 -4.73393 51.4037 -7.17812 40.0117 -0.891057C28.6198 5.396 23.6696 18.0335 28.9552 27.3357C34.2408 36.6378 47.7606 39.082 59.1526 32.7949Z",
    fill: "#F2A30D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9772 32.5982C69.0181 26.5294 73.832 14.3023 68.7295 5.28833C63.6269 -3.72566 50.54 -6.11316 39.4991 -0.0443046C28.4582 6.02455 23.6443 18.2516 28.7468 27.2656C33.8494 36.2796 46.9363 38.6671 57.9772 32.5982Z",
    fill: "#F2A40D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7304 32.151C68.4694 26.2481 73.1517 14.3552 68.1885 5.58745C63.2253 -3.1803 50.4962 -5.5027 39.7572 0.400209C29.0182 6.30312 24.3359 18.196 29.2991 26.9638C34.2623 35.7315 46.9914 38.0539 57.7304 32.151Z",
    fill: "#F2A50D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4672 31.6923C67.8971 25.9593 72.4452 14.4097 67.6256 5.89566C62.8061 -2.61839 50.4439 -4.87286 40.014 0.860163C29.584 6.59319 25.0359 18.1427 29.8555 26.6568C34.6751 35.1708 47.0372 37.4253 57.4672 31.6923Z",
    fill: "#F2A60D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2117 31.2321C67.3326 25.6689 71.7466 14.4628 67.0706 6.20241C62.3946 -2.05796 50.3994 -4.2445 40.2786 1.31864C30.1577 6.88178 25.7437 18.088 30.4197 26.3483C35.0957 34.6087 47.0909 36.7952 57.2117 31.2321Z",
    fill: "#F2A70D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3054 6.41256C70.7814 14.5043 66.5562 25.4931 56.8652 30.9431C47.1742 36.3931 35.6688 34.251 31.1781 26.1607C26.6873 18.0705 30.9251 7.06486 40.6161 1.61486C50.3071 -3.83514 61.8863 -1.70079 66.3054 6.41256Z",
    fill: "#F2A80D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7476 6.72078C70.0983 14.5605 66.005 25.2077 56.6047 30.4867C47.2043 35.7657 36.0831 33.6923 31.7303 25.8372C27.3774 17.9821 31.4749 7.36565 40.8731 2.0713C50.2713 -3.22306 61.4094 -1.13588 65.7476 6.72078Z",
    fill: "#F2A90D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2077 7.02681C69.4036 14.6177 65.4401 24.9081 56.3472 30.03C47.2543 35.1518 36.4834 33.1196 32.2727 25.5302C28.062 17.9409 32.0403 7.6489 41.1332 2.52706C50.226 -2.59478 60.9969 -0.562523 65.2077 7.02681Z",
    fill: "#F2AA0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6487 7.33393C68.6795 14.7082 64.8877 24.6218 56.1002 29.5711C47.3128 34.5204 36.8818 32.5615 32.8258 25.2211C28.7699 17.8806 32.5868 7.93322 41.3765 2.9993C50.1661 -1.93462 60.6223 -0.00961219 64.6487 7.33393Z",
    fill: "#F2AB0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9336 28.9775C64.5234 24.256 68.268 14.7423 64.2975 7.7281C60.3269 0.713921 50.1448 -1.14464 41.5551 3.57689C32.9653 8.29842 29.2207 17.8121 33.1912 24.8263C37.1618 31.8405 47.3439 33.699 55.9336 28.9775Z",
    fill: "#F2AC0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6743 28.5178C63.955 23.9661 67.5654 14.7958 63.7385 8.03534C59.9116 1.27485 50.0964 -0.515782 41.8158 4.03586C33.5351 8.5875 29.9246 17.7578 33.7515 24.5183C37.5785 31.2788 47.3936 33.0694 55.6743 28.5178Z",
    fill: "#F2AD0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4123 28.0722C63.3838 23.6905 66.8566 14.8576 63.1691 8.34344C59.4817 1.82927 50.0302 0.100547 42.0587 4.48224C34.0872 8.86394 30.6143 17.6968 34.3018 24.211C37.9893 30.7252 47.4408 32.4539 55.4123 28.0722Z",
    fill: "#F2AF0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4609 8.56405C65.9694 14.8857 62.6652 23.4686 55.0845 27.7292C47.5039 31.9898 38.5212 30.3153 35.0865 23.9859C31.6519 17.6565 34.8823 9.08134 42.4629 4.82075C50.0436 0.560162 58.9672 2.24089 62.4609 8.56405Z",
    fill: "#F2B00D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.8672 8.87627C65.221 14.9494 62.0485 23.1914 54.7728 27.2797C47.4971 31.368 38.8833 29.7637 35.5147 23.6921C32.1461 17.6206 35.3334 9.37702 42.6091 5.28871C49.8847 1.20041 58.5428 2.80006 61.8672 8.87627Z",
    fill: "#F2B10D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6429 26.7075C61.6944 22.8315 64.7672 15.0195 61.5064 9.25898C58.2455 3.49843 49.8857 1.97068 42.8342 5.84666C35.7827 9.72264 32.7099 17.5346 35.9708 23.2952C39.2317 29.0557 47.5915 30.5835 54.6429 26.7075Z",
    fill: "#F2B20D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3832 26.2481C61.1329 22.538 64.0775 15.0661 60.9602 9.5592C57.8428 4.05226 49.8441 2.59563 43.0944 6.30572C36.3447 10.0158 33.4001 17.4877 36.5175 22.9946C39.6348 28.5016 47.6336 29.9582 54.3832 26.2481Z",
    fill: "#F2B30D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.2632 9.79395C63.2118 15.1142 60.424 22.2551 54.0752 25.9027C47.7263 29.5503 40.1634 28.0693 37.1579 22.7706C34.1524 17.4719 36.9971 10.3094 43.3607 6.66027C49.7243 3.01114 57.3315 4.48747 60.2632 9.79395Z",
    fill: "#F2B40D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8755 25.3418C60.007 21.9715 62.6798 15.1805 59.8455 10.1736C57.0112 5.16662 49.7431 3.83984 43.6117 7.2101C37.4803 10.5804 34.8074 17.3714 37.6417 22.3784C40.476 27.3853 47.7441 28.7121 53.8755 25.3418Z",
    fill: "#F2B50D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.1695 10.4224C61.8357 15.2259 59.2614 21.7509 53.5681 25.0483C47.8748 28.3458 40.9923 27.0118 38.3261 22.2083C35.6599 17.4047 38.232 10.8644 43.9275 7.58231C49.6229 4.3002 56.5011 5.6035 59.1695 10.4224Z",
    fill: "#F2B60D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6203 10.7294C61.132 15.2846 58.7631 21.4611 53.3069 24.5311C47.8508 27.6012 41.3752 26.3956 38.8613 21.8251C36.3475 17.2545 38.7185 11.0935 44.1621 8.04033C49.6056 4.98721 56.0939 6.17579 58.6203 10.7294Z",
    fill: "#F2B70D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0731 11.0231C60.4597 15.3265 58.2078 21.1634 53.0524 24.0303C47.897 26.8972 41.7927 25.7773 39.4062 21.4739C37.0196 17.1705 39.2736 11.349 44.4269 8.4667C49.5801 5.58441 55.6887 6.73505 58.0731 11.0231Z",
    fill: "#F2B80D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5156 11.3456C59.7621 15.3983 57.6547 20.8766 52.7945 23.6031C47.9342 26.3297 42.1974 25.2647 39.9657 21.2104C37.734 17.1561 39.8266 11.6794 44.6868 8.95284C49.5471 6.22629 55.2839 7.29122 57.5156 11.3456Z",
    fill: "#F2B90D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5903 23.0731C57.1907 20.5444 59.1977 15.4518 57.073 11.6984C54.9484 7.94501 49.4966 6.95222 44.8962 9.48094C40.2958 12.0096 38.2888 17.1023 40.4135 20.8557C42.5382 24.609 47.9899 25.6018 52.5903 23.0731Z",
    fill: "#F2BA0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4168 11.9603C58.4107 15.494 56.5396 20.3081 52.2898 22.6897C48.04 25.0714 43.0416 24.147 41.0477 20.6133C39.0538 17.0796 40.9249 12.2655 45.1747 9.88383C49.4245 7.50219 54.4671 8.42192 56.4168 11.9603Z",
    fill: "#F2BB0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8779 12.2679C57.7022 15.554 55.9821 20.0555 52.0336 22.2337C48.0852 24.4119 43.4292 23.5763 41.5941 20.2134C39.7591 16.8504 41.4899 12.4258 45.4384 10.2476C49.3869 8.06939 54.0537 8.98179 55.8779 12.2679Z",
    fill: "#F2BC0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.326 12.5746C57.0103 15.6103 55.4325 19.7381 51.7937 21.7746C48.1548 23.811 43.8343 23.0181 42.1648 19.9808C40.4953 16.9435 42.0605 12.8326 45.6972 10.7808C49.3338 8.72903 53.6565 9.53731 55.326 12.5746Z",
    fill: "#F2BD0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7813 12.9264C56.3257 15.7119 54.8627 19.4847 51.4722 21.3703C48.0816 23.2559 44.1429 22.5163 42.6428 19.7262C41.1427 16.9361 42.5614 13.1679 45.952 11.2823C49.3425 9.39673 53.2305 10.0949 54.7813 12.9264Z",
    fill: "#F2BE0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2253 13.1898C55.6296 15.7247 54.3134 19.1542 51.2726 20.8625C48.2318 22.5708 44.6627 21.9016 43.2584 19.3667C41.8541 16.8319 43.1704 13.4023 46.2111 11.694C49.2519 9.98567 52.8232 10.6703 54.2253 13.1898Z",
    fill: "#F2BF0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6822 13.4948C54.9465 15.7793 53.7473 18.8691 51.0266 20.4034C48.3059 21.9376 45.0596 21.3279 43.7975 19.0588C42.5353 16.7897 43.7323 13.6845 46.4531 12.1503C49.1738 10.616 52.4201 11.2257 53.6822 13.4948Z",
    fill: "#F2C00D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1274 13.8036C54.2517 15.8376 53.1991 18.5843 50.769 19.9476C48.3389 21.3108 45.4769 20.7699 44.3547 18.7513C43.2326 16.7326 44.283 13.9705 46.7131 12.6072C49.1432 11.244 52.0053 11.7849 53.1274 13.8036Z",
    fill: "#F2C10D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.587 14.1254C53.5692 15.8937 52.6337 18.3006 50.5237 19.4897C48.4137 20.6789 45.8767 20.213 44.8946 18.4447C43.9124 16.6764 44.848 14.2696 46.9705 13.0635C49.0931 11.8574 51.6028 12.3418 52.587 14.1254Z",
    fill: "#F2C20D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0319 14.4357C52.2917 15.3204 52.2594 16.2568 51.94 17.0935C51.6207 17.9302 51.0331 18.6183 50.2723 19.0464C49.5114 19.4746 48.6218 19.6177 47.7473 19.4528C46.8729 19.2878 46.0647 18.8244 45.4535 18.1374C45.1937 17.2528 45.2261 16.3164 45.5454 15.4797C45.8647 14.643 46.4523 13.9549 47.2132 13.5267C47.974 13.0986 48.8636 12.9554 49.7381 13.1204C50.6125 13.2854 51.4207 13.7488 52.0319 14.4357Z",
    fill: "#F2C30D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4832 14.742C51.7211 15.4932 51.7051 16.2949 51.4379 17.0121C51.1708 17.7294 50.6687 18.3183 50.0164 18.6798C49.3641 19.0413 48.6014 19.1532 47.8566 18.9967C47.1118 18.8402 46.4305 18.4249 45.9275 17.8206C45.6896 17.0695 45.7056 16.2677 45.9728 15.5505C46.24 14.8333 46.742 14.2443 47.3943 13.8829C48.0466 13.5214 48.8094 13.4095 49.5541 13.566C50.2989 13.7224 50.9802 14.1378 51.4832 14.742Z",
    fill: "#F2C40D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9221 15.0381C51.2966 15.4581 51.5406 15.9826 51.6203 16.539C51.7001 17.0954 51.6116 17.656 51.3671 18.1431C51.1227 18.6302 50.7344 19.0197 50.2561 19.2575C49.7778 19.4952 49.2333 19.5695 48.698 19.47C48.1628 19.3706 47.6633 19.1022 47.2689 18.7023C46.8746 18.3023 46.6048 17.7906 46.4972 17.238C46.3895 16.6854 46.4492 16.1195 46.668 15.6186C46.8868 15.1177 47.2539 14.7067 47.7183 14.4427C48.2024 14.0897 48.8096 13.9543 49.409 14.0657C50.0084 14.1771 50.5518 14.5264 50.9221 15.0381Z",
    fill: "#F2C50D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3862 15.3458C50.6702 15.662 50.8557 16.0576 50.9171 16.4777C50.9786 16.8979 50.9127 17.3216 50.7289 17.6899C50.545 18.0583 50.2522 18.353 49.8912 18.5331C49.5302 18.7132 49.1189 18.7696 48.7146 18.6947C48.3103 18.6197 47.933 18.417 47.6352 18.1148C47.3374 17.8126 47.134 17.4259 47.0532 17.0084C46.9723 16.591 47.0181 16.1635 47.1842 15.7856C47.3502 15.4077 47.6283 15.098 47.9797 14.8996C48.344 14.6366 48.7994 14.5361 49.249 14.6195C49.6985 14.7028 50.1066 14.9635 50.3862 15.3458Z",
    fill: "#F2C60D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8304 15.6571C50.026 15.8669 50.1554 16.1324 50.2001 16.4158C50.2447 16.6992 50.2024 16.986 50.0791 17.2353C49.9558 17.4847 49.7578 17.6838 49.5134 17.8043C49.269 17.9248 48.9907 17.9606 48.718 17.9065C48.4454 17.8524 48.1924 17.7112 47.9952 17.5031C47.7979 17.2949 47.6664 17.0305 47.6195 16.7473C47.5726 16.4642 47.6126 16.177 47.7338 15.9265C47.855 15.676 48.0513 15.4751 48.2946 15.3524C48.5333 15.1992 48.8224 15.1455 49.106 15.2017C49.3896 15.258 49.6477 15.4202 49.8304 15.6571Z",
    fill: "#F2C70D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3042 15.9697C49.3618 16.1164 49.363 16.2781 49.3076 16.4206C49.2522 16.5631 49.1445 16.6753 49.0072 16.7335C48.9478 16.7782 48.8798 16.8098 48.8073 16.8264C48.7347 16.8431 48.6591 16.8445 48.5847 16.8306C48.5103 16.8167 48.4387 16.7877 48.374 16.7453C48.3093 16.703 48.2528 16.6481 48.2078 16.5839C48.1499 16.4392 48.1469 16.2794 48.1994 16.1376C48.2519 15.9957 48.356 15.8826 48.4901 15.8216C48.6136 15.7343 48.767 15.701 48.9185 15.7285C49.07 15.7561 49.2081 15.8424 49.3042 15.9697Z",
    fill: "#F2C80D"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6368 11.2075C50.6368 11.2075 60.0814 10.0595 64.1319 11.9946C68.1825 13.9297 73.2598 20.6713 73.2598 20.6713C73.2598 20.6713 79.2242 6.08383 76.4103 2.39536C73.5965 -1.29311 53.6873 9.31004 50.6368 11.2075Z",
    fill: "url(#paint0_linear_7562_78532)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.9841 111.43C80.1268 115.136 70.6183 117.034 61.0172 117.013C41.4967 116.5 27.8252 104.971 20.6404 86.1655C13.3542 66.7765 13.9702 37.6942 35.6825 22.8414C59.0538 6.94718 102.185 4.9564 118.07 29.9261C121.126 34.7159 123.37 39.9785 124.709 45.5006C130.806 70.5456 118.745 99.7671 88.9841 111.43Z",
    fill: "url(#paint1_linear_7562_78532)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.4746 108.523C59.2757 115.5 45.9392 113.38 36.1826 106.689L36.0664 106.611C28.9739 101.516 23.6064 94.3757 20.6829 86.1452C17.8297 78.4921 11.2987 59.164 22.6359 41.0685C32.1749 25.7564 63.5447 13.5159 83.5703 19.1886C89.2974 20.5918 94.2478 24.1824 97.3616 29.1915C110.806 51.7861 105.025 95.7556 75.4746 108.523Z",
    fill: "url(#paint2_radial_7562_78532)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M80.4705 115.091C102.954 112.358 118.565 88.6151 115.337 62.0596C112.109 35.504 91.2652 16.192 68.7812 18.925C46.2972 21.658 30.687 45.4011 33.9149 71.9566C37.1428 98.5122 57.9865 117.824 80.4705 115.091Z",
    fill: "url(#paint3_radial_7562_78532)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M79.1548 104.259C96.5806 102.141 108.68 83.7462 106.179 63.1731C103.678 42.6001 87.5247 27.6394 70.099 29.7575C52.6732 31.8757 40.5741 50.2706 43.0748 70.8436C45.5755 91.4167 61.7291 106.377 79.1548 104.259Z",
    fill: "url(#paint4_radial_7562_78532)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6303 91.6962C87.7967 90.4604 94.6234 77.8192 92.8782 63.4613C91.1329 49.1033 81.4766 38.4657 71.3102 39.7014C61.1438 40.9372 54.3171 53.5784 56.0624 67.9363C57.8076 82.2943 67.4639 92.9319 77.6303 91.6962Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M34.2044 115.878C41.2852 114.302 43.1261 95.505 38.3161 73.8948C33.5061 52.2847 23.8667 36.0443 16.7858 37.6209C9.705 39.1975 7.86412 57.9941 12.6741 79.6042C17.4841 101.214 27.1235 117.455 34.2044 115.878Z",
    fill: "url(#paint5_radial_7562_78532)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2182 73.5242C39.1254 90.2247 37.9607 105.252 32.5995 106.972C27.2382 108.692 19.7187 96.6752 15.8153 80.0048C11.9118 63.3343 13.0728 48.2773 18.4322 46.5419C23.7916 44.8065 31.2961 56.8255 35.2182 73.5242Z",
    fill: "url(#paint6_radial_7562_78532)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2506 74.8608C33.9627 86.5005 33.6125 96.8026 30.4445 97.8594C27.2765 98.9162 22.5079 90.3204 19.794 78.6656C17.0801 67.0108 17.4321 56.7238 20.6001 55.667C23.7681 54.6102 28.5367 63.2061 31.2506 74.8608Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.4756 108.523C59.2767 115.5 45.9402 113.38 36.1836 106.688C37.755 107.688 50.7337 117.912 74.4408 105.534C101.269 91.5863 111.475 34.3004 83.5864 19.1866C89.3134 20.5899 94.2638 24.1805 97.3776 29.1896C110.807 51.786 105.026 95.7555 75.4756 108.523Z",
    fill: "url(#paint7_linear_7562_78532)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1979 49.7143C19.1979 49.7143 18.0599 56.7992 27.9597 56.634C37.8594 56.4688 65.7209 40.8533 76.9359 36.8183C88.1509 32.7834 91.2724 27.0757 89.0642 24.3518C86.8559 21.6279 69.4404 14.8288 45.3866 25.2335C21.3328 35.6382 19.1979 49.7143 19.1979 49.7143Z",
    fill: "url(#paint8_linear_7562_78532)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9667 106.289C39.9667 106.289 49.2365 115.254 68.4572 107.65C72.5878 106.027 76.3062 103.506 79.3438 100.269C82.3815 97.0326 84.6625 93.1614 86.0221 88.9353C86.0221 88.9353 79.4471 100.131 62.5526 105.528C55.2105 107.694 47.4382 107.956 39.9667 106.289Z",
    fill: "url(#paint9_linear_7562_78532)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7472 91.1872C41.7472 91.1872 43.5858 93.7576 48.503 92.7782C53.4202 91.7989 55.4866 85.8225 55.4866 85.8225C55.4866 85.8225 55.7707 94.6887 50.8291 96.2206C44.9169 98.0538 41.7472 91.1872 41.7472 91.1872Z",
    fill: "url(#paint10_linear_7562_78532)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.608 20.7578C59.608 20.7578 61.6229 26.7876 70.5886 27.2245C81.6116 27.7625 83.8215 21.5855 83.5193 21.4849C75.7393 19.2176 67.5109 18.9674 59.608 20.7578Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.445 108.107C38.445 108.107 52.7085 120.74 78.6607 109.631C104.613 98.5224 107.115 67.501 103.745 49.071C103.745 49.071 109.148 91.0094 78.8185 106.284C53.8102 118.881 38.445 108.107 38.445 108.107Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.127 31.4234C102.241 35.6825 102.724 58.1121 117.083 64.7484C117.083 64.7484 122.725 64.9633 123.227 53.6505C123.748 41.3583 111.745 31.6266 105.127 31.4234Z",
    fill: "url(#paint11_linear_7562_78532)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.9884 111.431C80.131 115.137 70.6226 117.035 61.0214 117.013C61.0214 117.013 92.5989 115.145 103.489 97.6377C114.379 80.131 106.668 53.3585 106.668 53.3585L124.713 45.501C130.81 70.546 118.75 99.7674 88.9884 111.431Z",
    fill: "url(#paint12_linear_7562_78532)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7562_78532",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 10,
    width: 41,
    height: 52
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M117.972 61.7194C107.456 58.4649 103.506 37.8465 105.441 30.9209C105.715 30.0383 106.128 29.2137 106.663 28.4792C113.234 18.9075 141.188 5.79506 143.759 12.6496C146.555 20.148 128.489 64.9738 117.972 61.7194Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7562_78532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.459 5.47868L99.6797 10.1982L107.659 67.1202L152.438 62.4006L144.459 5.47868Z",
    fill: "#F2950D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.859 8.36237C151.99 21.2484 145.261 38.7226 129.836 47.3984C122.776 51.5106 114.492 53.0126 106.285 51.6679C102.72 51.0355 99.2851 49.6594 96.1922 47.6244L103.369 46.8689L98.0595 9.0393L128.857 5.79708L127.548 -3.52993C134.935 -2.14378 141.295 1.93471 144.859 8.36237Z",
    fill: "#F2950D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.311 8.66986C151.303 21.3061 144.705 38.4398 129.57 46.9451C122.641 50.9929 114.501 52.4688 106.442 51.139C102.948 50.5175 99.5821 49.1658 96.5531 47.1673L103.258 46.4614L98.007 9.0455L128.525 5.83271L127.289 -2.97284C134.58 -1.63873 140.81 2.37553 144.311 8.66986Z",
    fill: "#F2960D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.751 9.01086C150.609 21.3976 144.135 38.2118 129.301 46.554C122.508 50.5093 114.538 51.9569 106.641 50.6697C103.21 50.0572 99.9052 48.7289 96.9302 46.7665L103.186 46.1079L99.2219 17.8605L89.0709 18.9292C92.1439 11.5035 97.5552 5.45215 104.458 1.72209L105.385 8.32697L128.269 5.91779L127.101 -2.40743C134.2 -1.11288 140.32 2.80983 143.751 9.01086Z",
    fill: "#F2970D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.215 9.31811C149.934 21.4545 143.589 37.9122 129.047 46.0989C122.396 49.9785 114.587 51.393 106.853 50.1188C103.489 49.5294 100.249 48.2308 97.3347 46.3045L103.118 45.6956L99.2383 18.0473L89.6332 19.0585C92.6231 11.7632 97.92 5.81475 104.688 2.15137L105.551 8.29544L127.977 5.93441L126.88 -1.88392C130.195 -1.40014 133.392 -0.138444 136.224 1.80382C139.056 3.74607 141.448 6.31697 143.215 9.31811Z",
    fill: "#F2980D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.654 9.62778C149.233 21.5138 143.022 37.6455 128.783 45.6443C122.277 49.4381 114.638 50.8235 107.072 49.5822C103.782 49.0126 100.609 47.7552 97.7502 45.8876L103.077 45.3268L99.2697 18.201L90.2106 19.1547C93.1364 12.0074 98.3242 6.17972 104.955 2.59227L105.748 8.24476L127.702 5.93346L126.68 -1.34719C129.923 -0.869196 133.05 0.368827 135.819 2.27155C138.588 4.17428 140.926 6.69095 142.654 9.62778Z",
    fill: "#F2990D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.094 9.94301C148.551 21.5845 142.467 37.3694 128.526 45.2007C114.584 53.0319 98.05 49.9689 91.6073 38.3259L101.941 37.2379L99.2925 18.3641L90.7745 19.2609C93.6341 12.2674 98.6964 6.55661 105.169 3.02214L105.896 8.20168L127.405 5.93711L126.463 -0.779383C129.633 -0.309945 132.69 0.900324 135.4 2.7588C138.109 4.61728 140.399 7.0747 142.094 9.94301Z",
    fill: "#F29A0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.552 10.2504C147.853 21.6276 141.903 37.0863 128.266 44.745C114.63 52.4037 98.4553 49.4433 92.1483 38.02L101.877 36.9958L99.2886 18.5524L91.3169 19.3917C94.1219 12.5486 99.0881 6.96708 105.434 3.52542L106.094 8.22847L127.131 6.01366L126.251 -0.257077C129.356 0.199894 132.351 1.38483 135.004 3.2065C137.657 5.02817 139.897 7.43799 141.552 10.2504Z",
    fill: "#F29B0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.003 10.5779C147.161 21.6996 141.36 36.8085 128.02 44.2928C114.68 51.7771 98.8995 48.9175 92.7307 37.719L101.865 36.7574L99.3318 18.7065L91.9536 19.4833C94.6951 12.7987 99.5526 7.35044 105.758 3.99943C119.037 -3.49402 134.843 -0.559139 141.003 10.5779Z",
    fill: "#F29C0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.458 10.8838C146.476 21.7553 140.804 36.5078 127.772 43.8352C114.739 51.1625 99.3001 48.2825 93.2673 37.4124L101.826 36.5114L99.3511 18.875L92.4745 19.599C95.1609 13.0865 99.9063 7.78223 105.962 4.52249C118.987 -2.86629 134.433 -0.0338909 140.458 10.8838Z",
    fill: "#F29D0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.906 11.1921C145.799 21.8118 140.244 36.2244 127.517 43.3792C114.789 50.5341 99.6757 47.729 93.8271 37.1047L101.796 36.2658L99.3788 19.0444L93.0483 19.7109C95.6584 13.3252 100.292 8.11913 106.216 4.91759C118.944 -2.23724 134.028 0.570963 139.906 11.1921Z",
    fill: "#F29E0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.361 11.4989C145.09 21.8083 139.691 35.9395 127.298 42.9188C114.906 49.898 100.159 47.1478 94.4084 36.7939L101.787 36.0171L99.4323 19.2414L93.6331 19.8519C96.2105 13.607 100.767 8.52437 106.581 5.40929C118.893 -1.60827 133.623 1.12811 139.361 11.4989Z",
    fill: "#F29F0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.806 11.8057C144.419 21.9248 139.158 35.6518 127.011 42.4648C114.865 49.2779 100.517 46.5948 94.9208 36.4896L101.723 35.7734L99.421 19.3663L94.1677 19.9193C96.6588 13.839 101.074 8.88179 106.716 5.83049C118.848 -0.980991 133.204 1.65442 138.806 11.8057Z",
    fill: "#F2A00D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.854 41.8468C138.815 35.2722 144.029 22.0242 138.5 12.2566C132.97 2.48899 118.792 -0.0994928 106.831 6.47508C94.8701 13.0497 89.6561 26.2976 95.1853 36.0652C100.714 45.8329 114.893 48.4213 126.854 41.8468Z",
    fill: "#F2A10D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.592 41.3874C138.251 34.9787 143.337 22.0708 137.951 12.5568C132.566 3.04282 118.748 0.525464 107.089 6.93415C95.4301 13.3428 90.3444 26.2507 95.73 35.7647C101.116 45.2787 114.933 47.7961 126.592 41.3874Z",
    fill: "#F2A20D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.342 40.9413C137.692 34.7025 142.64 22.1321 137.394 12.8644C132.148 3.59673 118.694 1.1413 107.344 7.38004C95.9939 13.6188 91.0458 26.1892 96.292 35.4569C101.538 44.7246 114.992 47.18 126.342 40.9413Z",
    fill: "#F2A30D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.61 13.0559C141.663 22.1622 136.896 34.5171 125.987 40.6875C115.079 46.8579 102.136 44.3996 97.0974 35.2917C92.0593 26.1838 96.8121 13.8305 107.721 7.66008C118.629 1.48968 131.57 3.93262 136.61 13.0559Z",
    fill: "#F2A40D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.826 40.0358C136.565 34.1329 141.247 22.24 136.284 13.4723C131.321 4.7045 118.592 2.38209 107.853 8.285C97.1139 14.1879 92.4317 26.0808 97.3948 34.8486C102.358 43.6163 115.087 45.9387 125.826 40.0358Z",
    fill: "#F2A50D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.569 39.5766C135.999 33.8436 140.547 22.294 135.727 13.78C130.908 5.2659 118.545 3.01143 108.116 8.74445C97.6856 14.4775 93.1375 26.027 97.9571 34.5411C102.777 43.0551 115.139 45.3096 125.569 39.5766Z",
    fill: "#F2A60D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.316 39.131C135.437 33.5679 139.848 22.3558 135.168 14.0881C130.487 5.82032 118.489 3.62776 108.368 9.19084C98.2474 14.7539 93.837 25.966 98.5171 34.2337C103.197 42.5015 115.196 44.6941 125.316 39.131Z",
    fill: "#F2A70D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.059 38.6711C134.878 33.2739 139.16 22.4019 134.623 14.3878C130.087 6.37366 118.449 4.25222 108.63 9.64941C98.8114 15.0466 94.5292 25.9186 99.0658 33.9327C103.602 41.9469 115.24 44.0683 125.059 38.6711Z",
    fill: "#F2A80D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.792 38.2124C134.301 32.9851 138.45 22.4564 134.057 14.696C129.664 6.93556 118.393 4.88205 108.883 10.1094C99.3733 15.3367 95.2253 25.8653 99.6182 33.6257C104.011 41.3862 115.282 43.4397 124.792 38.2124Z",
    fill: "#F2A90D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.317 14.9011C137.513 22.4921 133.551 32.7981 124.456 37.9046C115.361 43.0111 104.594 41.0096 100.384 33.4201C96.1728 25.8307 100.149 15.5232 109.244 10.4167C118.339 5.31013 129.106 7.31169 133.317 14.9011Z",
    fill: "#F2AA0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.285 37.3069C133.184 32.4155 137.067 22.5643 132.957 15.3038C128.847 8.04332 118.301 6.12284 109.402 11.0143C100.503 15.9058 96.6209 25.7569 100.731 33.0174C104.841 40.2779 115.387 42.1984 124.285 37.3069Z",
    fill: "#F2AB0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.025 36.8608C132.615 32.1393 136.36 22.6256 132.389 15.6114C128.419 8.59724 118.237 6.73868 109.647 11.4602C101.057 16.1817 97.3125 25.6954 101.283 32.7096C105.254 39.7238 115.436 41.5823 124.025 36.8608Z",
    fill: "#F2AC0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.671 15.8534C135.462 22.6915 131.894 31.9576 123.702 36.5634C115.511 41.1692 105.819 39.351 102.043 32.5113C98.2666 25.6717 101.822 16.4225 110.014 11.8167C118.205 7.21092 127.893 8.99846 131.671 15.8534Z",
    fill: "#F2AD0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.123 16.131C134.759 22.7206 131.331 31.7074 123.436 36.0794C115.541 40.4515 106.211 38.7664 102.56 32.1784C98.9093 25.5903 102.352 16.6021 110.249 12.2454C118.147 7.8887 127.474 9.55837 131.123 16.131Z",
    fill: "#F2AF0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.566 16.438C134.077 22.7749 130.773 31.3578 123.192 35.6183C115.612 39.8788 106.629 38.2043 103.192 31.8596C99.7556 25.515 102.988 16.9553 110.569 12.6947C118.149 8.43421 127.071 10.0996 130.566 16.438Z",
    fill: "#F2B00D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.984 16.7662C133.338 22.8393 130.164 31.066 122.903 35.1527C115.642 39.2395 106.999 37.6383 103.63 31.5667C100.261 25.4952 103.449 17.2516 110.724 13.1633C118 9.075 126.658 10.6747 129.984 16.7662Z",
    fill: "#F2B10D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.744 34.5916C129.803 30.7117 132.882 22.8964 129.621 17.1358C126.36 11.3751 117.994 9.85058 110.935 13.7305C103.877 17.6105 100.798 25.4258 104.059 31.1864C107.32 36.947 115.685 38.4716 122.744 34.5916Z",
    fill: "#F2B20D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.936 17.3746C132.008 22.9314 129.114 30.489 122.434 34.2338C115.754 37.9786 107.865 36.5164 104.776 30.9457C101.687 25.375 104.613 17.8297 111.276 14.0712C117.939 10.3126 125.845 11.7885 128.936 17.3746Z",
    fill: "#F2B30D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.382 17.7593C131.329 23.0643 128.543 30.2206 122.192 33.8528C115.841 37.4851 108.282 36.0348 105.274 30.7207C102.267 25.4066 105.114 18.2594 111.479 14.6256C117.845 10.9919 125.437 12.3606 128.382 17.7593Z",
    fill: "#F2B40D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.973 33.2271C128.105 29.8568 130.777 23.0657 127.943 18.0588C125.109 13.0519 117.841 11.7251 111.709 15.0954C105.578 18.4656 102.905 25.2567 105.739 30.2636C108.574 35.2705 115.842 36.5973 121.973 33.2271Z",
    fill: "#F2B50D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.279 18.2969C129.945 23.1005 127.371 29.6254 121.677 32.9229C115.984 36.2204 109.102 34.8863 106.435 30.0828C103.769 25.2793 106.341 18.7389 112.037 15.4568C117.732 12.1747 124.61 13.478 127.279 18.2969Z",
    fill: "#F2B60D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.732 18.6042C129.244 23.1594 126.875 29.3358 121.419 32.4058C115.962 35.4758 109.487 34.2703 106.975 29.7152C104.463 25.16 106.818 18.9852 112.274 15.9151C117.73 12.8451 124.205 14.0506 126.732 18.6042Z",
    fill: "#F2B70D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.19 18.912C128.577 23.2154 126.325 29.0524 121.169 31.9193C116.014 34.7863 109.912 33.6817 107.525 29.3783C105.139 25.0748 107.391 19.2379 112.546 16.3709C117.701 13.5039 123.804 14.6085 126.19 18.912Z",
    fill: "#F2B80D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.638 19.2185C127.869 23.2728 125.764 28.7664 120.904 31.4929C116.044 34.2195 110.305 33.1392 108.075 29.1002C105.846 25.0613 107.934 19.5539 112.794 16.8274C117.654 14.1008 123.391 15.1658 125.638 19.2185Z",
    fill: "#F2B90D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.083 19.5261C127.189 23.3283 125.199 28.4664 120.706 31.0295C116.212 33.5925 110.767 32.575 108.663 28.7881C106.558 25.0013 108.544 19.8325 113.04 17.2848C117.536 14.7371 122.979 15.7393 125.083 19.5261Z",
    fill: "#F2BA0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.529 19.8341C126.525 23.383 124.652 28.1815 120.404 30.5784C116.157 32.9753 111.159 32.051 109.158 28.4713C107.158 24.8917 109.036 20.1239 113.285 17.7423C117.535 15.3608 122.58 16.2959 124.529 19.8341Z",
    fill: "#F2BB0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.987 20.1424C125.814 23.4438 124.092 27.9299 120.145 30.1235C116.199 32.317 111.541 31.4661 109.706 28.1032C107.871 24.7403 109.602 20.3157 113.55 18.1375C117.499 15.9593 122.163 16.8564 123.987 20.1424Z",
    fill: "#F2BC0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.43 20.4491C125.114 23.4848 123.536 27.6127 119.897 29.6491C116.258 31.6855 111.938 30.8926 110.268 27.8553C108.599 24.8181 110.164 20.7071 113.801 18.6553C117.437 16.6035 121.76 17.4118 123.43 20.4491Z",
    fill: "#F2BD0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.895 20.7716C124.438 23.5417 122.977 27.33 119.584 29.2003C116.191 31.0706 112.255 30.3463 110.754 27.5561C109.254 24.7659 110.673 20.9977 114.064 19.1121C117.454 17.2264 121.351 17.986 122.895 20.7716Z",
    fill: "#F2BE0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.339 21.0798C123.741 23.5993 122.425 27.0289 119.399 28.7356C116.373 30.4423 112.774 29.7762 111.37 27.2413C109.965 24.7065 111.282 21.2769 114.322 19.5686C117.363 17.8603 120.949 18.5433 122.339 21.0798Z",
    fill: "#F2BF0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.797 21.386C123.059 23.6552 121.86 26.7451 119.139 28.2794C116.419 29.8137 113.174 29.2194 111.91 26.9348C110.646 24.6502 111.845 21.5603 114.568 20.0414C117.291 18.5225 120.533 19.1014 121.797 21.386Z",
    fill: "#F2C00D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.228 21.6344C122.35 23.6532 121.298 26.4001 118.868 27.7634C116.437 29.1267 113.575 28.5858 112.453 26.567C111.331 24.5482 112.383 21.8014 114.814 20.438C117.244 19.0747 120.112 19.6618 121.228 21.6344Z",
    fill: "#F2C10D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.698 21.9992C121.681 23.7678 120.745 26.1752 118.634 27.3646C116.524 28.554 113.987 28.088 113.015 26.3962C112.044 24.7045 112.969 22.2202 115.094 21.0293C117.219 19.8383 119.716 20.2306 120.698 21.9992Z",
    fill: "#F2C20D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.141 22.3088C120.401 23.1935 120.369 24.1299 120.049 24.9666C119.73 25.8033 119.142 26.4913 118.382 26.9195C117.621 27.3476 116.731 27.4908 115.857 27.3258C114.982 27.1609 114.174 26.6974 113.563 26.0105C113.303 25.1258 113.335 24.1894 113.655 23.3527C113.974 22.516 114.562 21.8279 115.323 21.3998C116.083 20.9717 116.973 20.8285 117.847 20.9935C118.722 21.1584 119.53 21.6218 120.141 22.3088Z",
    fill: "#F2C30D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.587 22.6016C120.061 23.1284 120.371 23.7881 120.474 24.4888C120.577 25.1895 120.468 25.8964 120.161 26.5109C119.855 27.1254 119.366 27.617 118.764 27.9173C118.162 28.2175 117.476 28.3114 116.801 28.1859C116.127 28.0604 115.498 27.7217 115.002 27.217C114.506 26.7123 114.167 26.0668 114.033 25.3703C113.899 24.6738 113.977 23.9611 114.255 23.3313C114.534 22.7015 114.999 22.1861 115.586 21.8568C116.199 21.4404 116.951 21.2857 117.693 21.4238C118.434 21.5618 119.111 21.9824 119.587 22.6016Z",
    fill: "#F2C40D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.037 22.9126C119.416 23.3341 119.664 23.8617 119.746 24.4221C119.828 24.9825 119.741 25.5477 119.495 26.0392C119.25 26.5306 118.86 26.9238 118.378 27.1639C117.896 27.404 117.348 27.4792 116.808 27.379C116.269 27.2788 115.766 27.0081 115.369 26.6046C114.972 26.2012 114.701 25.6851 114.594 25.1282C114.486 24.5712 114.548 24.0011 114.77 23.4973C114.992 22.9935 115.364 22.5809 115.833 22.3171C116.319 21.9681 116.925 21.8351 117.523 21.9462C118.121 22.0574 118.664 22.4041 119.037 22.9126Z",
    fill: "#F2C50D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.491 23.2216C118.775 23.5377 118.961 23.9334 119.022 24.3535C119.083 24.7736 119.018 25.1973 118.834 25.5657C118.65 25.9341 118.357 26.2288 117.996 26.4089C117.635 26.5889 117.224 26.6454 116.819 26.5704C116.415 26.4955 116.038 26.2928 115.74 25.9906C115.442 25.6883 115.239 25.3016 115.158 24.8841C115.077 24.4667 115.123 24.0393 115.289 23.6613C115.455 23.2834 115.733 22.9737 116.084 22.7753C116.45 22.5162 116.905 22.4179 117.353 22.5011C117.801 22.5842 118.209 22.8424 118.491 23.2216Z",
    fill: "#F2C60D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.942 23.5322C118.137 23.7419 118.267 24.0074 118.311 24.2908C118.356 24.5742 118.314 24.861 118.19 25.1104C118.067 25.3597 117.869 25.5588 117.625 25.6793C117.38 25.7998 117.102 25.8356 116.829 25.7815C116.557 25.7274 116.304 25.5862 116.106 25.3781C115.909 25.1699 115.778 24.9055 115.731 24.6224C115.684 24.3393 115.724 24.052 115.845 23.8015C115.966 23.551 116.163 23.3501 116.406 23.2274C116.645 23.0742 116.934 23.0205 117.217 23.0767C117.501 23.133 117.759 23.2953 117.942 23.5322Z",
    fill: "#F2C70D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.406 23.8442C117.436 23.9167 117.453 23.9942 117.454 24.0721C117.456 24.1499 117.443 24.2267 117.415 24.2978C117.387 24.3689 117.346 24.4329 117.293 24.4862C117.241 24.5395 117.178 24.5809 117.109 24.608C117.049 24.6527 116.981 24.6843 116.909 24.701C116.836 24.7177 116.761 24.7191 116.686 24.7052C116.612 24.6913 116.54 24.6623 116.476 24.6199C116.411 24.5775 116.354 24.5226 116.309 24.4584C116.251 24.3137 116.248 24.154 116.301 24.0121C116.353 23.8703 116.458 23.7571 116.592 23.6961C116.715 23.6088 116.869 23.5755 117.02 23.6031C117.172 23.6306 117.31 23.7169 117.406 23.8442Z",
    fill: "#F2C80D"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.233 18.7921C119.233 18.7921 126.585 18.8907 128.979 20.1265C131.373 21.3622 136.906 39.0101 136.906 39.0101C136.906 39.0101 148.654 15.3838 144.624 11.2324C140.594 7.08111 119.233 18.7921 119.233 18.7921Z",
    fill: "url(#paint13_linear_7562_78532)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.198 61.544C106.533 58.5503 102.987 38.2945 105.128 31.4236C105.43 30.5473 105.871 29.7255 106.434 28.99C106.434 28.99 102.867 38.1869 109.067 40.105C109.067 40.105 129.416 14.0287 144.688 12.615C147.381 19.9518 127.863 64.5376 117.198 61.544Z",
    fill: "url(#paint14_linear_7562_78532)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.085 14.786C127.085 14.786 126.807 16.5144 132.837 15.9036C138.868 15.2927 140.254 10.8799 140.254 10.8799C135.642 11.2596 131.159 12.5895 127.085 14.786Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7562_78532",
    x1: 67.2663,
    y1: 22.0868,
    x2: 62.9885,
    y2: 3.9812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#B4B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCFDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7562_78532",
    x1: 83.6513,
    y1: 113.636,
    x2: 59.8864,
    y2: 12.8622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#B4B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCFDFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_7562_78532",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.2925 43.9023) rotate(-6.93046) scale(59.2812 59.3035)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2553CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#0030C3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_7562_78532",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.127 66.9624) rotate(-6.93046) scale(41.1431 48.4218)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#F23D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#C03000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#7C1F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#471200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#200800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#090200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_7562_78532",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.128 66.9627) rotate(-6.93046) scale(31.8843 37.525)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#F20000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#C00000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#7C0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#470000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#200000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#090000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_7562_78532",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.3448 77.6043) rotate(-17.9438) scale(13.0817 39.9375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#F23D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#C03000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#7C1F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#471200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#200800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#090200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_7562_78532",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.4365 76.0997) rotate(-18.6599) scale(10.3082 30.9142)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#F20000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#C00000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#7C0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#470000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#200000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#090000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7562_78532",
    x1: 73.9885,
    y1: 110.979,
    x2: 63.1332,
    y2: 21.6728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#540068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81899A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7562_78532",
    x1: 56.2405,
    y1: 53.2574,
    x2: 52.3764,
    y2: 21.4678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#615BA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7562_78532",
    x1: 64.4802,
    y1: 109.584,
    x2: 62.3131,
    y2: 91.7561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF931F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7562_78532",
    x1: 41.8708,
    y1: 92.4546,
    x2: 56.0527,
    y2: 90.7308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#540068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81899A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7562_78532",
    x1: 115.716,
    y1: 64.9298,
    x2: 111.549,
    y2: 30.6428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81899A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#540068"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_7562_78532",
    x1: 57.2077,
    y1: 85.8894,
    x2: 128.869,
    y2: 77.1788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92A2CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_7562_78532",
    x1: 137.703,
    y1: 38.7911,
    x2: 131.487,
    y2: 12.4021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#DEF4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_7562_78532",
    x1: 104.769,
    y1: 40.3985,
    x2: 147.54,
    y2: 35.1995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9898E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHead);
export default __webpack_public_path__ + "static/media/Head.a214405731b93c77ac7ca689bfe31e06.svg";
export { ForwardRef as ReactComponent };